module.exports = __webpack_public_path__ + "static/media/edit-icon.f88d1240.svg";